/** Display name of a thread for lists and headers. */
import type { ThreadDto } from '@oex/contracts';
import type { TFunction } from '../../../app/i18n';

export function threadTitle(
  t: TFunction,
  thread: ThreadDto,
  myUserId: string | null,
  myOrgId: string | null,
): string {
  if (thread.title) return thread.title;
  if (thread.kind === 'context' && thread.contextKind) return t(`messaging.context.${thread.contextKind}`);
  const others = thread.participants.filter((p) => (p.userId ? p.userId !== myUserId : p.orgId !== myOrgId));
  const names = others.map((p) =>
    p.user?.fullName
      ? `${p.user.fullName}${p.orgId !== myOrgId ? ` · ${p.org.displayName}` : ''}`
      : p.org.displayName,
  );
  return names.join(', ') || t('messaging.thread.untitled');
}
